module.exports = __webpack_public_path__ + "static/img/investor3.8caaa058.png";